<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <b-tabs
          content-class="mt-3"
          active-nav-item-class="font-weight-bold"
          v-model="currentTab"
        >
          <b-tab title="Form" active>
            <b-form
              class="p-2"
              @submit.prevent="onSubmit"
              :method="'POST'"
              :action="route"
            >
              <input type="hidden" name="_token" :value="csrf" />
              <input type="hidden" name="_method" value="POST" />

              <common-loading
                :message="
                  selected_message == null
                    ? $t('pharmaops.fetching_program')
                    : $t('pharmaops.fetching_message_template')
                "
                v-if="states.fetching"
              />

              <common-loading
                :message="$t('pharmaops.removing_message_template')"
                v-if="states.removing"
              />

              <b-alert
                :show="!(permissions.indexOf('pharmaops-edit') !== -1)"
                variant="warning"
              >
                <em class="fa fa-info-circle mr-2"></em>
                {{ $t("commons.read_only") }}
              </b-alert>

              <div class="row">
                <div class="col-lg-6 pr-3 pl-3">
                  <b-form-group
                    id="fieldset-name"
                    label-for="name"
                    label-size="lg"
                    label-class="font-weight-bold pb-0"
                  >
                    <template slot="label">
                      <span v-text="$t('pharmaops.name')" />
                      <a
                        href="#"
                        v-b-tooltip.hover
                        :title="$t('pharmaops.name_tooltip')"
                        type="primary"
                        class="fa fa-question-circle text-decoration-none"
                      >
                      </a>
                    </template>
                    <b-form-input
                      id="name"
                      name="name"
                      v-model.trim="name"
                      :placeholder="$t('pharmaops.enter_name')"
                      :disabled="
                        disableForm ||
                        !(
                          permissions.indexOf('pharmaops-edit') !== -1 &&
                          permissions.indexOf('pharmaops-read') !== -1
                        )
                      "
                    />
                    <div v-if="hasError('name')">
                      <div
                        class="alert alert-danger mt-1"
                        v-if="states.showErrors"
                        v-text="$t('commons.required_field_error')"
                      ></div>
                    </div>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 pr-3">
                  <b-form-group
                    id="fieldset-active"
                    label-for="active"
                    label-size="lg"
                    label-class="font-weight-bold pb-0"
                  >
                    <template slot="label">
                      <span v-text="$t('commons.active')" />
                    </template>

                    <toggle-button
                      v-model="isActive"
                      :labels="{ checked: 'On', unchecked: 'Off' }"
                      :sync="true"
                    />
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 pr-3 pl-3">
                  <b-form-group
                    id="fieldset-message-engine"
                    label-for="originationNumber"
                    label-size="lg"
                    label-class="font-weight-bold pb-0"
                  >
                    <template slot="label">
                      <span v-text="$t('pharmaops.originationNumber')" />
                    </template>
                    <b-form-input
                      id="originationNumber"
                      name="originationNumber"
                      v-model.trim="originationNumber"
                      :placeholder="$t('pharmaops.enter_origination_number')"
                      disabled
                    />
                  </b-form-group>
                </div>
                <div class="col-lg-6 pr-3">
                  <b-form-group
                    id="fieldset-country-code"
                    label-for="countryCode"
                    label-size="lg"
                    label-class="font-weight-bold pb-0"
                  >
                    <template slot="label">
                      <span v-text="$t('pharmaops.countryCode')" />
                    </template>
                    <b-form-input
                      id="countryCode"
                      name="countryCode"
                      v-model.trim="countryCode"
                      maxlength="200"
                      :placeholder="$t('pharmaops.enter_country_code')"
                      readonly
                    />
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 pr-3 pl-3">
                  <b-form-group
                    id="fieldset-message-engine"
                    label-for="messageEngine"
                    label-size="lg"
                    label-class="font-weight-bold pb-0"
                  >
                    <template slot="label">
                      <span v-text="$t('pharmaops.messageEngine')" />
                    </template>
                    <b-form-input
                      id="messageEngine"
                      name="messageEngine"
                      v-model.trim="messageEngine"
                      :placeholder="$t('pharmaops.enter_message_engine')"
                      disabled
                    />
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12 pt-3">
                  <b-form-group
                    label-for="type"
                    label-size="lg"
                    label-class="font-weight-bold pb-0"
                  >
                    <template slot="label">
                      <span
                        v-text="$t('pharmaops.auto_reply_message_templates')"
                      />
                      <em
                        class="fa fa-gear fa-spin text-primary"
                        v-if="states.fetching || states.removing"
                      ></em>
                      <a
                        href="#"
                        v-b-tooltip.hover
                        :title="$t('pharmaops.mt_tooltip')"
                        type="primary"
                        class="fa fa-question-circle text-decoration-none"
                      >
                      </a>
                    </template>

                    <b-tabs
                      content-class="mt-3"
                      active-nav-item-class="font-weight-bold"
                      v-model="interaction"
                    >
                      <b-tab title="Inbound" active>
                        <div
                          v-if="
                            !states.fetching && inbound_messages.length == 0
                          "
                          class="row pb-1"
                        >
                          <div class="col-lg-5 pr-3 pl-3">
                            <div>
                              <span
                                class="font-weight-bold text-primary"
                                v-text="$t('pharmaops.no_message_templates')"
                              />
                            </div>
                          </div>
                        </div>

                        <div
                          v-if="!states.fetching && inbound_messages.length"
                          class="row pb-1"
                        >
                          <div class="col-lg-2 pr-3 pl-3">
                            <div>
                              <span
                                class="font-weight-bold text-primary"
                                v-text="$t('pharmaops.keyword')"
                              />
                            </div>
                          </div>
                          <div class="col-lg-8 pr-3 pl-3">
                            <div>
                              <span
                                class="font-weight-bold text-primary"
                                v-text="$t('pharmaops.message')"
                              />
                            </div>
                          </div>
                        </div>

                        <div
                          v-for="(message, index) in inbound_messages"
                          :key="message.messageTemplateId"
                        >
                          <div class="row">
                            <div class="col-lg-2 pr-3 pl-3">
                              <b-form-textarea
                                id="key"
                                name="key"
                                :value="message.keyword"
                                readonly
                                no-resize
                                max-rows="1"
                              />
                            </div>
                            <div class="col-lg-8 pr-3 pb-3">
                              <b-form-textarea
                                id="message.messageTemplateId"
                                name="key"
                                :value="message.message"
                                readonly
                              />
                            </div>
                            <div class="row col-lg-2 pr-3">
                              <b-form-group>
                                <b-button
                                  v-if="!states.approvalProcessEnabled"
                                  variant="primary"
                                  :disabled="
                                    disableForm ||
                                    !(
                                      permissions.indexOf('pharmaops-edit') !==
                                        -1 &&
                                      permissions.indexOf('pharmaops-read') !==
                                        -1 &&
                                      permissions.indexOf('message-read') !==
                                        -1 &&
                                      permissions.indexOf('message-edit') !== -1
                                    )
                                  "
                                  @click="fetchMessage(message.id, index)"
                                  class="mr-3"
                                >
                                  <i class="fa-solid fa-pen-to-square"></i>
                                </b-button>
                              </b-form-group>
                              <b-form-group>
                                <b-button
                                  variant="danger"
                                  :disabled="
                                    disableForm ||
                                    !(
                                      permissions.indexOf('pharmaops-edit') !==
                                        -1 &&
                                      permissions.indexOf('pharmaops-read') !==
                                        -1 &&
                                      permissions.indexOf('message-read') !==
                                        -1 &&
                                      permissions.indexOf('message-edit') !== -1
                                    )
                                  "
                                  @click="
                                    confirmDeleteMessageTemplate(
                                      message.id,
                                      index
                                    )
                                  "
                                  class="mr-1"
                                >
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-form-group>
                            </div>
                          </div>
                        </div>

                        <div v-if="!states.fetching" class="row pb-1">
                          <div class="col-lg-5 pr-3 pl-3">
                            <b-button
                              variant="success"
                              class="mt-2"
                              @click="addMessage()"
                              :disabled="
                                disableForm ||
                                !(
                                  permissions.indexOf('pharmaops-edit') !==
                                    -1 &&
                                  permissions.indexOf('pharmaops-read') !== -1
                                )
                              "
                              ><em class="fa fa-plus"></em
                            ></b-button>
                          </div>
                        </div>
                      </b-tab>

                      <b-tab title="Outbound">
                        <div
                          v-if="
                            !states.fetching && outbound_messages.length == 0
                          "
                          class="row pb-1"
                        >
                          <div class="col-lg-5 pr-3 pl-3">
                            <div>
                              <span
                                class="font-weight-bold text-primary"
                                v-text="$t('pharmaops.no_message_templates')"
                              />
                            </div>
                          </div>
                        </div>

                        <div
                          v-if="!states.fetching && outbound_messages.length"
                          class="row pb-1"
                        >
                          <div class="col-lg-2 pr-3 pl-3">
                            <div>
                              <span
                                class="font-weight-bold text-primary"
                                v-text="$t('pharmaops.name')"
                              />
                            </div>
                          </div>
                          <div class="col-lg-8 pr-3 pl-3">
                            <div>
                              <span
                                class="font-weight-bold text-primary"
                                v-text="$t('pharmaops.message')"
                              />
                            </div>
                          </div>
                        </div>

                        <div
                          v-for="(message, index) in outbound_messages"
                          :key="message.messageTemplateId"
                        >
                          <div class="row">
                            <div class="col-lg-2 pr-3 pl-3">
                              <b-form-textarea
                                id="name"
                                name="name"
                                :value="message.name"
                                readonly
                                no-resize
                                max-rows="1"
                              />
                            </div>
                            <div class="col-lg-8 pr-3 pb-3">
                              <b-form-textarea
                                id="message.messageTemplateId"
                                name="message"
                                :value="message.message"
                                readonly
                              />
                            </div>
                            <div class="row col-lg-2 pr-3">
                              <b-form-group>
                                <b-button
                                  v-if="!states.approvalProcessEnabled"
                                  variant="primary"
                                  :disabled="
                                    disableForm ||
                                    !(
                                      permissions.indexOf('pharmaops-edit') !==
                                        -1 &&
                                      permissions.indexOf('pharmaops-read') !==
                                        -1 &&
                                      permissions.indexOf('message-read') !==
                                        -1 &&
                                      permissions.indexOf('message-edit') !== -1
                                    )
                                  "
                                  @click="fetchMessage(message.id, index)"
                                  class="mr-3"
                                >
                                  <i class="fa-solid fa-pen-to-square"></i>
                                </b-button>
                              </b-form-group>
                              <b-form-group>
                                <b-button
                                  variant="danger"
                                  :disabled="
                                    disableForm ||
                                    !(
                                      permissions.indexOf('pharmaops-edit') !==
                                        -1 &&
                                      permissions.indexOf('pharmaops-read') !==
                                        -1 &&
                                      permissions.indexOf('message-read') !==
                                        -1 &&
                                      permissions.indexOf('message-edit') !== -1
                                    )
                                  "
                                  @click="
                                    confirmDeleteMessageTemplate(
                                      message.id,
                                      index
                                    )
                                  "
                                  class="mr-1"
                                >
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-form-group>
                            </div>
                          </div>
                        </div>

                        <div v-if="!states.fetching" class="row pb-1">
                          <div class="col-lg-5 pr-3 pl-3">
                            <b-button
                              variant="success"
                              class="mt-2"
                              @click="addMessage()"
                              :disabled="
                                disableForm ||
                                !(
                                  permissions.indexOf('pharmaops-edit') !==
                                    -1 &&
                                  permissions.indexOf('pharmaops-read') !== -1
                                )
                              "
                              ><em class="fa fa-plus"></em
                            ></b-button>
                          </div>
                        </div>
                      </b-tab>
                    </b-tabs>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12 p-3">
                  <b-form-group
                    label-for="type"
                    label-size="lg"
                    label-class="font-weight-bold pb-0"
                  >
                    <template slot="label">
                      <span v-text="$t('pharmaops.message_properties')" />
                      <em
                        class="fa fa-gear fa-spin text-primary"
                        v-if="states.fetching || states.removing"
                      ></em>
                    </template>

                    <div class="row pb-1" v-if="messageProperties != null">
                      <div class="col-lg-6 pr-3 pl-3">
                        <div>
                          <span
                            class="font-weight-bold text-primary"
                            v-text="$t('pharmaops.key')"
                          />
                        </div>
                      </div>
                      <div class="col-lg-6 pr-3 pl-3">
                        <div>
                          <span
                            class="font-weight-bold text-primary"
                            v-text="$t('pharmaops.value')"
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      v-for="(message, index) in messageProperties"
                      :key="index"
                    >
                      <div class="row">
                        <div class="col-lg-6 pr-3 pl-3">
                          <b-form-input
                            id="key"
                            name="key"
                            :value="index"
                            readonly
                          />
                        </div>
                        <div class="col-lg-6 pr-3 pb-3">
                          <b-form-input
                            id="message"
                            name="message"
                            :value="message"
                            readonly
                          />
                        </div>
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </div>

              <div class="row justify-content-end align-items-end w-100">
                <b-form-group>
                  <b-button
                    type="submit"
                    class="mr-2"
                    variant="primary"
                    v-text="$t('buttons.update')"
                    :disabled="
                      disableForm ||
                      !(permissions.indexOf('pharmaops-edit') !== -1)
                    "
                  ></b-button>
                  <b-button
                    class="btn btn-danger"
                    v-text="$t('buttons.cancel')"
                    :href="$routes('dashboard')"
                    :disabled="disableForm"
                  ></b-button>
                </b-form-group>
              </div>

              <common-loading
                :message="$t('pharmaops.saving')"
                v-if="states.saving"
              />
              <b-alert
                variant="danger"
                :show="states.showErrors && hasErrors()"
              >
                <em class="fa fa-times-circle mr-2"></em>
                {{ $t("commons.form_error") }}
              </b-alert>
              <b-alert variant="success" :show="states.showSuccess">
                <em class="fa fa-check-circle mr-2"></em>
                {{ $t("pharmaops.saved_successfully") }}
              </b-alert>

              <b-alert variant="success" :show="states.removeSuccess">
                <em class="fa fa-check-circle mr-2"></em>
                {{ $t("pharmaops.removed_successfully") }}
              </b-alert>

              <b-alert variant="success" :show="states.addedSuccess">
                <em class="fa fa-check-circle mr-2"></em>
                {{ $t("pharmaops.mt_added_successfully") }}
              </b-alert>

              <b-alert variant="danger" :show="errorMessage != null">
                <em class="fa fa-times-circle mr-2"></em>
                <span v-html="errorMessage"></span>
              </b-alert>
            </b-form>
          </b-tab>
        </b-tabs>

        <confirmation-modal ref="confirmModal"></confirmation-modal>
        <message-modal ref="messageModal"></message-modal>
      </div>
    </div>
  </div>
</template>

<script>
import PharmaopsApi from "../../../apis/PharmaopsApi";
import MessagesApi from "../../../apis/MessagesApi";
import { useSearch } from "../../../stores/search";
import { useManageAttributes } from "../../../stores/manage-attributes";

export default {
  props: {
    permissions: {
      type: Array,
    },
  },
  computed: {
    id: {
      get() {
        return this.useManageAttributes.getForm.id;
      },
      set(value) {
        this.useManageAttributes.updateValue({
          key: "id",
          value: value,
        });
      },
    },
    form() {
      return this.useManageAttributes.getForm;
    },
    name: {
      get() {
        return this.useManageAttributes.getForm.name;
      },
      set(value) {
        this.useManageAttributes.updateValue({
          key: "name",
          value: value,
        });
      },
    },
    messageEngine: {
      get() {
        return this.useManageAttributes.getForm.messageEngine;
      },
    },
    originationNumber: {
      get() {
        return this.useManageAttributes.getForm.originationNumber;
      },
    },
    countryCode: {
      get() {
        return this.useManageAttributes.getForm.countryCode;
      },
    },
    messageProperties: {
      get() {
        return this.useManageAttributes.getForm.messageProperties;
      },
    },
    isActive: {
      get() {
        return this.useManageAttributes.getForm.isActive;
      },
      set(value) {
        this.useManageAttributes.updateValue({
          key: "isActive",
          value: value,
        });
      },
    },
    states() {
      return this.useManageAttributes.states;
    },
    errors() {
      return this.useManageAttributes.errors;
    },
    errorMessage() {
      return this.useManageAttributes.errorMessage;
    },
    // ...mapGetters({
    //   //originalData: "manageAttributes/originalData",
    // }),
    disableForm() {
      return this.useManageAttributes.disableForm;
    },
    disableCancel() {
      return this.useManageAttributes.disableCancel;
    },
    hasOriginalDataChanged() {
      return this.useManageAttributes.hasOriginalDataChanged;
    },
  },
  watch: {
    "states.showMessageTemplateSuccess": function (newVal, oldVal) {
      if (newVal) {
        this.clearMessages();
      }
    },
    "states.showAddedMessageTemplateSuccess": function (newVal, oldVal) {
      if (newVal) {
        this.clearMessages();
      }
    },
  },
  data() {
    return {
      programId: window.Laravel.selected_instance
        ? window.Laravel.selected_instance.id
        : null,
      csrf: null,
      route: null,
      PharmaopsApi: PharmaopsApi,
      currentTab: 0,
      selected_message: null,
      inbound_messages: [],
      inbound_message_templates: [],
      outbound_messages: [],
      outbound_message_templates: [],
      interaction: 0,
      message_properties: {},
      useManageAttributes: useManageAttributes(),
      useSearch: useSearch(),
    };
  },
  created() {
    this.initForm();

    this.useManageAttributes.setPermissions(this.permissions);
    this.useManageAttributes.setDocumentId(this.programId);

    this.csrf = document.head.querySelector('meta[name="csrf-token"]').content;
    this.fetchProgram();
  },
  methods: {
    setCurrentTab(index) {
      this.currentTab = this.tabs[index];
    },
    initForm() {
      let formData = {
        result: {
          id: null,
          name: null,
          messageEngine: null,
          originationNumber: null,
          countryCode: null,
          messageProperties: null,
          isActive: null,
        },
      };
      this.useManageAttributes.initialize(formData);
    },
    hasErrors() {
      return (
        !this.form.name ||
        this.form.name.length == 0 ||
        !this.form.id ||
        this.form.id.length == 0
      );
    },
    onSubmit(e) {
      this.useManageAttributes.updateStates({
        showErrors: true,
      });

      if (this.hasErrors()) {
        this.$toast.error("Error", this.$t("commons.form_error"));
        return;
      }

      this.updateProgram();
    },
    hasError(field) {
      if (!this.form[field] || this.form[field].length == 0) {
        this.useManageAttributes.updateErrors({ [field]: true });
        return true;
      } else {
        this.useManageAttributes.updateErrors({ [field]: false });
        return false;
      }
    },
    fetchProgram() {
      this.inbound_messages = [];
      this.outbound_messages = [];
      this.useManageAttributes.updateStates({
        adding_pu_form: false,
        saving_pu_form: false,
        fetching: true,
      });
      PharmaopsApi.find(this.programId)
        .then((r) => {
          this.useManageAttributes.initialize(r.data);
          this.useManageAttributes.setApprovalProcessStatus(r.data.result);
          this.useManageAttributes.updateHeaders(r.headers);

          let params = {
            returns: "id,attributes",
            filters: "attributes.type=inbound",
            limit: 100000,
          };
          MessagesApi.all(params, this.programId)
            .then((response) => {
              response.result.forEach((element) => {
                let found = false;
                this.form.messagesList.forEach((message) => {
                  if (message.messageTemplateId == element.id) {
                    found = true;
                    let item = {
                      id: element.id,
                      type: "inbound",
                      keyword: message.keyword,
                      message: element.attributes.message,
                    };
                    this.inbound_messages.push(item);
                  }
                });
                if (
                  !found &&
                  element.id != "default-message" &&
                  element.attributes.type == "inbound" &&
                  (!element.status ||
                    (element.status && element.status == "APPROVED"))
                ) {
                  this.inbound_message_templates.push(element);
                }
              });

              let params = {
                returns: "id,attributes",
                filters: "attributes.type=outbound",
                limit: 100000,
              };
              MessagesApi.all(params, this.programId)
                .then((response) => {
                  response.result.forEach((element) => {
                    let found = false;
                    this.form.messagesList.forEach((message) => {
                      if (message.messageTemplateId == element.id) {
                        found = true;
                        let item = {
                          id: element.id,
                          type: "outbound",
                          name: element.name,
                          message: element.attributes.message,
                        };
                        this.outbound_messages.push(item);
                      }
                    });
                    if (
                      !found &&
                      element.id != "default-message" &&
                      element.attributes.type == "outbound" &&
                      (!element.status ||
                        (element.status && element.status == "APPROVED"))
                    ) {
                      this.outbound_message_templates.push(element);
                    }
                  });
                  this.useManageAttributes.updateStates({
                    fetching: false,
                  });
                })
                .catch((e) => {
                  this.useSearch.updateStates({
                    fetching: false,
                    hasError: true,
                  });
                  let errorMessage = this.$t("messages.search_failed");
                  if (e.response && e.response.status == 400) {
                    errorMessage = e.response.data.data.detail;
                  }
                  this.$toast.error("Error", errorMessage);
                });
            })
            .catch((e) => {
              this.useSearch.updateStates({
                fetching: false,
                hasError: true,
              });
              let errorMessage = this.$t("messages.search_failed");
              if (e.response && e.response.status == 400) {
                errorMessage = e.response.data.data.detail;
              }
              this.$toast.error("Error", errorMessage);
            });
        })
        .catch((e) => {
          let errorMessage = this.$t("pharmaops.find_failed");
          if (e.response && e.response.status == 404) {
            errorMessage = this.$t("commons.not_found");
            this.useManageAttributes.updateStates({
              fetching: false,
              invalid: true,
            });
          } else {
            this.useManageAttributes.updateStates({
              fetching: false,
            });
          }
          this.useManageAttributes.setErrorMessage(errorMessage);
          this.$toast.error("Error", errorMessage);
        });
    },
    createParams() {
      let url = "id'in'";
      this.form.messagesList.forEach((message) => {
        url += message.messageTemplateId + "[]";
      });

      let params = {
        filters: url,
        limit: 100000,
      };
      return params;
    },
    addMessage() {
      let message_template = {
        instanceId: this.id,
      };
      this.$refs.messageModal
        .open(
          this.states.approvalProcessEnabled,
          message_template,
          this.interaction,
          this.interaction == 0
            ? this.inbound_message_templates
            : this.outbound_message_templates
        )
        .then((response) => {
          if (response) {
            this.updateProgram();
          }
        });
    },
    fetchMessage(id, selected) {
      this.selected_message = selected;
      this.useManageAttributes.updateStates({
        fetching: true,
      });
      this.useManageAttributes.setDocumentId(id);
      MessagesApi.find(id, this.programId)
        .then((r) => {
          this.useManageAttributes.updateStates({
            fetching: false,
          });
          this.selected_message = null;
          this.$refs.messageModal
            .open(this.states.approvalProcessEnabled, r, this.interaction, [])
            .then((response) => {
              if (response) {
                this.updateProgram();
              }
            });
        })
        .catch((e) => {
          let errorMessage = this.$t("pharmaops.find_failed");
          if (e.response && e.response.status == 404) {
            errorMessage = this.$t("commons.not_found");
            this.useManageAttributes.updateStates({
              fetching: false,
              invalid: true,
            });
          } else {
            this.useManageAttributes.updateStates({
              fetching: false,
            });
          }
          this.useManageAttributes.setErrorMessage(errorMessage);
          this.$toast.error("Error", errorMessage);
        });
    },
    removeMessage(id, selected) {
      this.selected_message = selected;
      this.useManageAttributes.updateStates({
        removing: true,
        removeSuccess: false,
        showSuccess: false,
        addedSuccess: false,
      });

      const auto_replies =
        this.originalData.attributes.message.settings.default.autoReplies;
      for (const key in auto_replies) {
        if (id == auto_replies[key].messageTemplateId) {
          delete this.originalData.attributes.message.settings.default
            .autoReplies[key];
        }
      }

      this.useManageAttributes.setErrorMessage(null);
      let eTag = null;
      let headers = this.useManageAttributes.headers;

      if (headers && headers["ETag"] && headers["ETag"].length > 0) {
        eTag = headers["ETag"][0];
      }

      let payload = {
        payload: this.originalData,
      };
      delete payload.payload["modifiedBy"];

      PharmaopsApi.removeMessageTemplate(this.programId, payload.payload)
        .then((r) => {
          this.$toast.success(
            "Success",
            this.$t("pharmaops.removed_successfully")
          );
          this.selected_message = null;
          this.clearMessages();

          this.useManageAttributes.updateHeaders(r.headers);
          this.useManageAttributes.updateStates({
            removing: false,
            showErrors: false,
            removeSuccess: true,
          });
        })
        .catch((e) => {
          this.useManageAttributes.updateStates({
            removing: false,
          });

          let errorMessage = "Unable to remove program";
          if (e.response.status == 412) {
            errorMessage = this.$t("commons.optimistic_lock");
            this.useManageAttributes.setErrorMessage(errorMessage);
            this.invalid = true;
          } else if (e.response.status == 400) {
            errorMessage = e.response.data.data.detail;
            this.useManageAttributes.setErrorMessage(errorMessage);
          }
          this.$toast.error("Error", errorMessage);
        });
    },
    updateProgram() {
      this.useManageAttributes.updateStates({
        saving: true,
        showSuccess: false,
        removeSuccess: false,
      });
      this.useManageAttributes.setErrorMessage(null);

      let eTag = null;
      let headers = this.useManageAttributes.headers;

      if (headers && headers["ETag"] && headers["ETag"].length > 0) {
        eTag = headers["ETag"][0];
      }

      let payload = {
        payload: {
          id: this.form.id,
          name: this.form.name,
          isActive: this.form.isActive,
          attributes: this.originalData.attributes,
        },
        eTag: eTag,
      };

      PharmaopsApi.update(this.programId, payload)
        .then((r) => {
          this.useManageAttributes.updateStates({
            showSuccess: true,
          });

          this.$toast.success(
            "Success",
            this.$t("pharmaops.saved_successfully")
          );

          this.useManageAttributes.updateHeaders(r.headers);
          this.useManageAttributes.updateStates({
            showErrors: false,
            showSuccess: true,
            saving: false,
          });
        })
        .catch((e) => {
          this.useManageAttributes.updateStates({
            saving: false,
          });

          let errorMessage = "Unable to update program";
          if (e.response.status == 412) {
            errorMessage = this.$t("commons.optimistic_lock");
            this.useManageAttributes.setErrorMessage(errorMessage);
            this.invalid = true;
          } else if (e.response.status == 400) {
            errorMessage = e.response.data.data.detail;
            this.useManageAttributes.setErrorMessage(errorMessage);
          }

          this.$toast.error("Error", errorMessage);
        });
    },
    clearMessages() {
      this.inbound_message_templates = [];
      this.outbound_message_templates = [];
      this.form.messagesList = [];
      this.fetchProgram();
    },
    confirmDeleteMessageTemplate(id, selected) {
      this.$refs.confirmModal
        .open(this.$t("commons.confirm_delete"))
        .then((response) => {
          if (response) {
            this.removeMessage(id, selected);
          }
        });
    },
  },
};
</script>
